"use strict";import{logger}from"../logger/index.js";export function setGestureState(){logger.warn("setGestureState() is not available on web.")}